import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './SimpleLanguageSwitcher.css';

/**
 * SimpleLanguageSwitcher - A simple toggle component for switching between English and Chinese
 * 
 * Features:
 * - Simple toggle button showing "English" or "中文"
 * - Click toggles between en and zh
 * - Shows current language highlighted
 * - Clean, minimal design
 */
export const SimpleLanguageSwitcher: React.FC = () => {
  const { uiLanguage, setUILanguage } = useLanguage();

  const handleToggle = async () => {
    const newLanguage = uiLanguage === 'en' ? 'zh' : 'en';
    try {
      await setUILanguage(newLanguage);
    } catch (error) {
      console.error('Failed to change language:', error);
    }
  };

  return (
    <button
      className="simple-language-switcher"
      onClick={handleToggle}
      aria-label={`Switch to ${uiLanguage === 'en' ? 'Chinese' : 'English'}`}
      title={`Switch to ${uiLanguage === 'en' ? 'Chinese' : 'English'}`}
    >
      <span className={`language-option ${uiLanguage === 'en' ? 'active' : ''}`}>
        English
      </span>
      <span className="language-divider">|</span>
      <span className={`language-option ${uiLanguage === 'zh' ? 'active' : ''}`}>
        中文
      </span>
    </button>
  );
};

export default SimpleLanguageSwitcher;
